<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-flex>
      <app-upsert
        :config="config"
        :item="item"
        @saved="saved "/>

    </v-flex>

  </v-container>
</template>

<script>

import config from './config_new.js'

export default {
  data ({ $store }) {
    let item = {}
    if ($store.getters.user.site_id) {
      item.site_id = $store.getters.user.site_id
    }
    if ($store.getters.app.protocol.id !== -1) {
      item.protocol_id = $store.getters.app.protocol.id
    }
    return {
      config,
      item
    }
  },
  methods: {
    saved ({ data }) {
      this.$router.push(`/siterequest/${data.id}`)
    }
  }
}
</script>
